module.exports = __webpack_public_path__ + "static/rappi-4-7e851d255667d98426e31c8ee4d4817c.jpg";